/* ==========================================================================
   DEMIGODS — transparent header
   Publishes its own height so the hero can pad content clear of it, and
   remembers a dismissed announcement bar for the rest of the session.
   ========================================================================== */

(function () {
  'use strict';

  var STORAGE_KEY = 'dg-announcement-dismissed';

  function publishHeight(head) {
    var h = head.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--dg-header-offset', Math.round(h) + 'px');
  }

  function readDismissed() {
    try {
      return window.sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false; // private mode, or storage disabled
    }
  }

  function writeDismissed() {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {
      /* nothing we can do, and nothing that needs doing */
    }
  }

  /* ------------------------------------------------------------------- menu */

  /* The panel is closed by CSS, not by a hidden attribute, so it stays shut
     with no JavaScript and can still fade. All this does is flip the flag and
     keep the button, the page's scroll and the keyboard in step with it. */
  function initNav(head) {
    var toggle = head.querySelector('[data-dg-nav-toggle]');
    var panel = head.querySelector('[data-dg-nav]');
    if (!toggle || !panel) return;

    var links = panel.querySelectorAll('[data-dg-nav-link]');

    function setOpen(open) {
      panel.setAttribute('data-open', open ? 'true' : 'false');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('dg-nav-open', open);
      document.body.classList.toggle('dg-nav-open', open);

      if (open) {
        /* Send the keyboard into the panel, not left behind the overlay. */
        if (links.length) links[0].focus();
      } else {
        toggle.focus();
      }
    }

    function isOpen() {
      return panel.getAttribute('data-open') === 'true';
    }

    toggle.addEventListener('click', function () {
      setOpen(!isOpen());
    });

    /* A tap on the panel's own background closes it. Links and anything else
       inside stop the event by being the target themselves. */
    panel.addEventListener('click', function (event) {
      if (event.target === panel || event.target.classList.contains('dg-head__nav-inner')) {
        setOpen(false);
      }
    });

    /* Same-page anchors do not reload, so the panel would stay over the
       section the visitor just asked to see. */
    Array.prototype.forEach.call(links, function (link) {
      link.addEventListener('click', function () { setOpen(false); });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen()) setOpen(false);
    });
  }

  function init(scope) {
    var heads = (scope || document).querySelectorAll('[data-dg-head]');

    Array.prototype.forEach.call(heads, function (head) {
      if (head.getAttribute('data-dg-head-ready') === 'true') return;
      head.setAttribute('data-dg-head-ready', 'true');

      var bar = head.querySelector('[data-dg-announcement]');
      var close = head.querySelector('[data-dg-announcement-close]');

      if (bar && readDismissed()) bar.hidden = true;

      if (close && bar) {
        close.addEventListener('click', function () {
          bar.hidden = true;
          writeDismissed();
          publishHeight(head);
        });
      }

      function remeasure() {
        publishHeight(head);
      }

      remeasure();

      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(remeasure);
        ro.observe(head);

        /* Watch the logo itself, not only the bar. A cached image can report
           complete while still having no laid-out box, and the bar's height
           does not always change when the logo's does. */
        var slot = head.querySelector('.dg-head__logo-slot');
        if (slot) ro.observe(slot);
      } else {
        window.addEventListener('resize', remeasure);
      }

      var img = head.querySelector('.dg-head__logo-img');
      if (img) img.addEventListener('load', remeasure);

      /* Webfonts and late stylesheets both change the bar after DOMContentLoaded. */
      window.addEventListener('load', remeasure);

      initNav(head);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
